var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var header = ref.header;
var item = ref.item;
var v = ref.value;
return [(header.getRoute)?_c('router-link',{attrs:{"to":header.getRoute(item)},domProps:{"textContent":_vm._s(v)}}):[_vm._v(" "+_vm._s(v)+" ")]]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }